import axios from 'axios';

const source = axios.CancelToken.source();
let config = {cancelToken: source.token};

const badgesUrls = {
	badges: '/biro/achievements',
	updateLastNotifiedLevel: '/biro/achievements/updateLastNotifiedLevel',
};

export async function getBadgesData(wengeAttendee, wengeEvent) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + badgesUrls.badges;

	return axios(
		{
			method: 'POST',
			url: requestUrl,
			data: {
				wengeAttendee,
				wengeEvent,
			},
		},
		config,
	);
}

export async function updateLastNotifiedLevel(badge, wengeAttendee, wengeEvent) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + badgesUrls.updateLastNotifiedLevel;

	return axios(
		{
			method: 'POST',
			url: requestUrl,
			data: {
				wengeAttendee,
				wengeEvent,
				badgeName: badge.name,
				level: badge.level,
			},
		},
		config,
	);
}
